export default __webpack_public_path__ + "static/media/eseasa_construcciones.5efc12f9.png";